import React, { Component } from "react";

import { Table, DatePicker, Input, Button , Divider} from "antd";

import { httpGet, httpUrl } from "../../api/httpClient";
import {formatDate } from "../../util";
import InquiryDetailModal from "../../components/community/InquiryDetailModal";
const Search = Input.Search;
const { RangePicker } = DatePicker;

class Inquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pagination: {
        total: 0,
        current: 1
      },
      searchText:"",
      inquiryModalVisible: false,
      selectedDate: {},

    };
  }

  componentDidMount() {
    this.getInquiryList();
  }

  changeShowContent = (idx) => {
    if (this.state.showAnswer === idx) {
        this.setState({
            showAnswer: 0,
        });
    } else
        this.setState({
            showAnswer: idx,
        });
};

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getInquiryList());
  };

 
  getInquiryList = () => {
    let pageNum = this.state.pagination.current;
 
    httpGet(httpUrl.inquiryList, [10,pageNum], {}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        list: res.data.list,
        pagination,
      });
    });
  };
 
  onClose = () => {
    this.setState({
      inquiryModalVisible: false,   
    })
    this.getInquiryList();
  }

  render() {
    const { list } = this.state;

    const columns = [
      {
        title: "",
        dataIndex: "idx",
        key: "idx",
        width: 50,
        className: "support-column-number fs-15 lh-21",
      },
      // {
      //   title: "작성자",
      //   dataIndex: "userIdx",
      //   key: "userIdx",
      //   width: 100,
      //   className: "support-column-number fs-15 lh-21",
      // },
      {
        title: "작성자",
        dataIndex: "userName",
        key: "userName",
        width: 150,
        className: "support-column-number fs-15 lh-21",
        render:(data,row) =>(
          <div>
            {data}
            <div>
            {row.userId}
            </div>
        </div>
        )
      },      
      {
        title: "문의내용",
        dataIndex: "title",
        key: "title",
        width: 500,
        className: "",
        render: (data,row) => (
            <div>           
            {data}
            </div>
       )
      
      },    
      {
        title: "답변",
        dataIndex: "answer",
        key: "answer",
        width: 200,      
        className: "",
        render: data => <div className="text-ellipsis2">{data  !== null ? data : "-"}</div>
      },  
      {
        title: "등록일",
        dataIndex: "createDate",       
        className: "support-column-number fs-15 lh-21",
        width: 200,
        render: data => <div>{formatDate(data)}</div>
      }, 
      {
        title: "답변일",
        dataIndex: "updateDate",       
        className: "support-column-number fs-15 lh-21",
        width: 200,
        render: data => <div>{data !== null ? formatDate(data) : "-"}</div>
      }, 
      {
        title: "",
        dataIndex: "",
        width: 100,
        className: "support-column-number fs-15 lh-21",
        render: (row) => <div>
          <Button
           onClick={() => {
            this.setState({
              inquiryModalVisible: true,
              selectedDate: row,
            })
           }}
          >답변하기</Button></div>
      },
   

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          <Divider orientation="left" style={{fontSize:23}}>1:1 문의관리 </Divider>
      </div>
        <div className="wrapper mt-35 width-1240" />
        <div>
         
        </div>
        {this.state.inquiryModalVisible && 
        <InquiryDetailModal
        data={this.state.selectedDate}
        title="상세보기"
        visible={this.state.inquiryModalVisible}
        onClose={this.onClose}
        />
        }
        <Table
          rowKey={(record) => record.idx}
        //   rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={this.state.list}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
     
      </div>
    );
  }
}

export default Inquiry;
